<template>
  <div class="card mt-3">    
    <h1>{{weatherforecasts[0].Tn}}°</h1>
    <img v-if="weatherforecasts[0].Icone == 'pn'" width="120" height="120" src="https://res.cloudinary.com/das1rnjvi/image/upload/v1672362550/bluelogic/weather/cloudy-day-2_hqutas.svg"/>
    <img v-else-if="weatherforecasts[0].Icone == 'pc'" width="120" height="120" src="https://res.cloudinary.com/das1rnjvi/image/upload/v1672362555/bluelogic/weather/thunder_l1s6ft.svg"/>
    <img v-else-if="weatherforecasts[0].Icone == 'pi'" width="120" height="120" src="https://res.cloudinary.com/das1rnjvi/image/upload/v1672362552/bluelogic/weather/rainy-1_vrolm5.svg"/>
    <img v-else-if="weatherforecasts[0].Icone == 'nc'" width="120" height="120" src="https://res.cloudinary.com/das1rnjvi/image/upload/v1672362553/bluelogic/weather/rainy-6_pnygds.svg"/>
    <table>
      <tr>
        <td v-for="weatherforecast in weatherforecasts"><b>{{ weatherforecast.DiaSemana }}</b></td>
      </tr>
      <tr>
        <td v-for="weatherforecast in weatherforecasts">max. {{ weatherforecast.Tmax }}°</td>
      </tr>
      <tr>
        <td v-for="weatherforecast in weatherforecasts">min. {{ weatherforecast.Tmin }}°</td>
      </tr>

    </table>
  </div>
</template>
<script>
export default {
  props: {
    weatherforecasts: [],
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {



  },
  mounted() {

  },
  methods: {

  },
}
</script>
<style scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:400,300);

html,
body {
  background-color: #F3F3F3;
  font-family: 'Roboto', sans-serif;
}

.card {
  margin: 0 auto;
  margin-top: 5px;
  width: 100%;
  height: 100%;
  -webkit-animation: open 2s cubic-bezier(.39, 0, .38, 1);
}

h1,
h2,
h3,
h4 {
  position: relative;
}

h1 {
  float: right;
  color: #666;
  font-weight: 300;
  font-size: 5.59375em;
  line-height: .2em;
  -webkit-animation: up 2s cubic-bezier(.39, 0, .38, 1) .2s;
}

h2 {
  font-weight: 300;
  font-size: 2.25em;
  -webkit-animation: up 2s cubic-bezier(.39, 0, .38, 1);
}

h3 {
  float: left;
  margin-right: 33px;
  color: #777;
  font-weight: 400;
  font-size: 1em;
  -webkit-animation: up 2s cubic-bezier(.39, 0, .38, 1) .1s;
}

span {
  margin-left: 24px;
  color: #999;
  font-weight: 300;
}

span span {
  margin-left: 0;
}

.dot {
  font-size: .9em;
}

.sky {
  position: relative;
  margin-top: 20px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #03A9F4;
  -webkit-animation: up 2s cubic-bezier(.39, 0, .38, 1) .2s;
}

.sun {
  position: relative;
  top: -3px;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  background-color: #FFEB3B;
  -webkit-animation: up 2s cubic-bezier(.39, 0, .38, 1) .5s;
}

.cloud {
  position: absolute;
  top: 60px;
  left: 30px;
  -webkit-animation: up 2s cubic-bezier(.39, 0, .38, 1) .7s;
}

.cloud:before,
.cloud:after {
  position: absolute;
  display: block;
  content: "";
}

.cloud:before {
  margin-left: -10px;
  width: 51px;
  height: 18px;
  background: #fff;
}

.cloud:after {
  position: absolute;
  top: -10px;
  left: -22px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 50px -6px 0 6px #fff, 25px -19px 0 10px #fff;
}

table {
  position: relative;
  top: 10px;
  width: 100%;
  text-align: center;
}

tr:nth-child(1) td:nth-child(1),
tr:nth-child(1) td:nth-child(2),
tr:nth-child(1) td:nth-child(3),
tr:nth-child(1) td:nth-child(4),
tr:nth-child(1) td:nth-child(5) {
  padding-bottom: 12px;
  -webkit-animation: up 2s cubic-bezier(.39, 0, .38, 1) .7s;
}

tr:nth-child(2) td:nth-child(1),
tr:nth-child(2) td:nth-child(2),
tr:nth-child(2) td:nth-child(3),
tr:nth-child(2) td:nth-child(4),
tr:nth-child(2) td:nth-child(5) {
  padding-bottom: 17px;
  -webkit-animation: up 2s cubic-bezier(.39, 0, .38, 1) .9s;
}

tr:nth-child(3) td:nth-child(1),
tr:nth-child(3) td:nth-child(2),
tr:nth-child(3) td:nth-child(3),
tr:nth-child(3) td:nth-child(4),
tr:nth-child(3) td:nth-child(5) {
  padding-bottom: 17px;
  -webkit-animation: up 2s cubic-bezier(.39, 0, .38, 1) .9s;
}

tr:nth-child(2),
tr:nth-child(3) {
  font-size: .9em;
}

tr:nth-child(3) {
  color: #999;
}

@-webkit-keyframes up {
  0% {
    opacity: 0;
    -webkit-transform: translateY(15px);
  }

  50% {
    opacity: 0;
    -webkit-transform: translateY(15px);
  }

  99% {
    -webkit-animation-play-state: paused;
  }

  100% {
    opacity: 1;
  }
}
</style>
